// @flow
import styled from "styled-components";
import colors from '../../assets/css/colors';

export const TableGrid = styled.div.attrs({
	role: 'table',
	'aria-label': props => (props.label ? props.label : undefined)
})`
	width: 100%;
	box-shadow: ${colors.box_shadow};
`;

export default TableGrid;


// WEBPACK FOOTER //
// ./src/components/Table/TableGrid.js